import dateFnsFormat from 'date-fns/format';
const languageLocals: { [key: string]: string } = {
  'en-US': 'en',
  'fr-FR': 'fr',
  'it-IT': 'it',
  'da-DK': 'da',
  'en-GB': 'en-gb',
  'es-419': 'es',
  'es-ES': 'es',
  'de-DE': 'de'
};

export const formatDate = (date: Date, format: string) => {
  let FORMAT = 'dd/MM/yyyy';
  switch (format) {
    case 'DD/MM/YYYY':
      FORMAT = 'dd/MM/yyyy';
      break;
    case 'MM/DD/YYYY':
      FORMAT = 'MM/dd/yyyy';
      break;
    case 'YYYY/MM/DD':
      FORMAT = 'yyyy/MM/dd';
      break;
    default:
      FORMAT = 'dd/MM/yyyy';
      break;
  }
  return dateFnsFormat(date, FORMAT);
};

export const decideLocale = (languageSelected: string) => {
  if (languageLocals[languageSelected]) {
    return languageLocals[languageSelected];
  }
  return 'en';
};

export const checkIsNullOrUndefined = (value: boolean | undefined | null) => {
  return value === null || value === undefined;
};
